
import React from 'react';

interface SignInWithBaseButtonProps {
    colorScheme?: 'light' | 'dark';
    onClick?: () => void;
    className?: string; // Allow custom styling
}

export const SignInWithBaseButton: React.FC<SignInWithBaseButtonProps> = ({
    colorScheme = 'light',
    onClick,
    className
}) => {
    const isLight = colorScheme === 'light';

    return (
        <button
            type="button"
            onClick={onClick}
            className={className}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '12px 16px',
                backgroundColor: isLight ? '#ffffff' : '#000000',
                border: isLight ? '1px solid #e5e7eb' : 'none', // Added border for light mode visibility
                borderRadius: '8px',
                cursor: 'pointer',
                fontFamily: 'system-ui, -apple-system, sans-serif',
                fontSize: '14px',
                fontWeight: '500',
                color: isLight ? '#000000' : '#ffffff',
                minWidth: '180px',
                height: '44px',
                transition: 'opacity 0.2s ease',
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = '0.9')}
            onMouseOut={(e) => (e.currentTarget.style.opacity = '1')}
        >
            <div style={{
                width: '16px',
                height: '16px',
                backgroundColor: isLight ? '#0000FF' : '#FFFFFF',
                borderRadius: '2px',
                flexShrink: 0
            }} />
            <span>Sign in with Base</span>
        </button>
    );
};
